import { render, staticRenderFns } from "./BaseModal.vue?vue&type=template&id=a1d64aaa&scoped=true"
import script from "./BaseModal.vue?vue&type=script&lang=js"
export * from "./BaseModal.vue?vue&type=script&lang=js"
import style0 from "./BaseModal.vue?vue&type=style&index=0&id=a1d64aaa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d64aaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1d64aaa')) {
      api.createRecord('a1d64aaa', component.options)
    } else {
      api.reload('a1d64aaa', component.options)
    }
    module.hot.accept("./BaseModal.vue?vue&type=template&id=a1d64aaa&scoped=true", function () {
      api.rerender('a1d64aaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/investments/fee-schedule-list-manager/BaseModal.vue"
export default component.exports